<template>
  <div class="grade-template">
    <div class="grade-top">
      <div class="grade-top-left">
        <span v-has="'02010015'" class="btn-span"><el-button type="primary" @click="preserved" :disabled="saveBtn?false:true" :loading="loadSave">保存</el-button></span>
        <span v-has="'02010016'" class="btn-span"><el-button type="primary" @click="delButton" :disabled="saveBtn?false:true" :loading="loadDel">删除</el-button></span>
        <span v-has="'02010066'" class="btn-span"><el-button type="primary" @click="scorBtn">综合打分</el-button></span>
      </div>
      <div class="grade-top-right">
       <el-dropdown :hide-on-click="false" @command="handleCommand" v-has="'02010017'">
            <span class="el-dropdown-link">导出<i class="el-icon-arrow-down el-icon--right"></i></span>
            <el-dropdown-menu slot="dropdown">
              <el-dropdown-item :command="exportTemplateURl">导出模板</el-dropdown-item>
              <el-dropdown-item :command="exporDetailtURl">导出明细</el-dropdown-item>
            </el-dropdown-menu>
          </el-dropdown>
        <m-import
          :num="'2'"
          :disabled="saveBtn?false:true"
          :params="uploadParams"
          :uploadUrl="uploadUrl"
          @import-callback='success'
          resourceId='02010018'
        >
          <span slot="button-name">导入评分模板</span>
        </m-import>
      </div>
    </div>
    <div class="grade-table">
      <el-table
      ref="table"
        :data="tableData"
        style="width: 100%"
        row-key="id"
        border
        height="40"
        :tree-props="{children: 'childList', hasChildren: 'hasChildren'}"
        highlight-current-row
        @select="select"
        @select-all="selectAll"
      >
        <el-table-column type="selection" width="45"></el-table-column>
        <el-table-column prop="scoreAttribute" label="评分属性" width="130">
          <template slot-scope="scope">{{conversionData(scope.row.scoreAttribute)}}</template>
        </el-table-column>
        <el-table-column prop="scoreItem" label="评分项" width="280"></el-table-column>
        <el-table-column prop="scoreStandard" label="评分标准" width="480"></el-table-column>
        <el-table-column prop="scoreScale" label="权重(%)" width="210">
          <template slot-scope="scope">
            <div class="input-box" v-if="scope.row.children?false:true">
               <el-input-number v-model="scope.row.scoreScale" :disabled="scope.row.disabled?true:false" @change="inputScore(scope.row,scope)"
                :precision="2" controls-position="right"  :step="1" :min="0" :max="99999" ></el-input-number>
            </div>
            <span v-else>{{scope.row.scoreScale}}</span>
          </template>
        </el-table-column>
        <el-table-column prop label></el-table-column>
      </el-table>
    </div>
  </div>
</template>
<script>
import { scoreList, saveList, delList } from '../../../../../lsrm/api/bidScheme.js';
import mImport from '../../../../components/importFile/Import2';
import config from '@/config/user.env';
import { dictWithUrl } from '@/components/lots/api';
export default {
    components: { mImport },
    data() {
        return {
            loadSave: false,
            loadDel: false,
            allSelect: false,
            bidStatus: '',
            saveBtn: '',
            scoreScale: '',
            expandList: [],
            loaclDel: [],
            fileObj: {},
            tableData: [],
            dictData: {}, // 数字字典
            // 导入
            uploadUrl: '/api-srm-web/bid/importCompositeScore',
            uploadParams: {},
            // 导出明细
            exporDetailtURl: '/api-srm-web/bid/exportCompositeScore',
            exportName: '综合评分明细.xls',
            exportParams: {},
            // 导出模板
            exportTemplateURl: '/api-srm-web/bid/exportCompositeScoreTemplate',
            exportTemplateName: '综合评分模板.xls'
        };
    },
    mounted() {
        // 数字字典转换
        dictWithUrl('BID_SCORING_ATTRIBUTE').then(res => {
            this.dictData = res.data;
            this.init();
        });
    },
    methods: {
        selectAll(selection, row) {
            this.allSelect = !this.allSelect;
            if (this.allSelect) {
                this.tableData.forEach(item => {
                    item.isCheck = true;
                    this.$refs.table.toggleRowSelection(item, true);
                    item.childList.forEach(item2 => {
                        item2.isCheck = true;
                        this.$refs.table.toggleRowSelection(item2, true);
                    });
                });
            } else {
                this.tableData.forEach(item => {
                    item.isCheck = false;
                    this.$refs.table.toggleRowSelection(item, false);
                    item.childList.forEach(item2 => {
                        item2.isCheck = false;
                        this.$refs.table.toggleRowSelection(item2, false);
                    });
                });
            }
        },
        select(selection, row) {
            if (!row.childList) {
                row.isCheck = !row.isCheck;
                const res = this.tableData.find(item => {
                    return item.childList.indexOf(row) !== -1;
                });
                const haveIsCheck = [];
                res.childList.forEach(item => {
                    if (item.isCheck) {
                        haveIsCheck.push(item);
                    }
                    if (haveIsCheck.length === res.childList.length) {
                        res.isCheck = true;
                        this.$refs.table.toggleRowSelection(res, true);
                    } else {
                        res.isCheck = false;
                        this.$refs.table.toggleRowSelection(res, false);
                    }
                });
                return;
            }
            row.isCheck = !row.isCheck;
            this.tableData.forEach(item => {
                if (item.isCheck) {
                    item.childList.forEach(item2 => {
                        item2.isCheck = true;
                        this.$refs.table.toggleRowSelection(item2, true);
                    });
                } else {
                    item.childList.forEach(item2 => {
                        item2.isCheck = false;
                        this.$refs.table.toggleRowSelection(item2, false);
                    });
                }
            });
        },

        /** 导出 **/
        handleCommand(command) {
            let apiUrl = '';
            if (window.location.origin !== 'http://localhost.annto.com:8080') {
                apiUrl = config.apiUrl;
            }
            window.location = apiUrl + command;
        },
        // 保存
        async preserved() {
            if (this.tableData[0]) {
                if (this.tableData[0].scoreScale * 1 !== 100) {
                    this.$message.error(this.tableData[0].scoreName + '权重累计不等于100%');
                    return false;
                }
            }
            if (this.tableData[1]) {
                if (this.tableData[1].scoreScale * 1 !== 100) {
                    this.$message.error(this.tableData[1].scoreName + '权重累计不等于100%');
                    return false;
                }
            }
            this.loadSave = true;
            const res = await saveList([...new Set(this.expandList)]);
            this.loadSave = false;
            if (res && res.code === '0') {
                this.$message({
                    message: '保存成功',
                    type: 'success'
                });
            }
        },
        success() {
            this.init();
        },
        // 删除
        async delButton() {
            const delData = [];
            this.tableData.forEach(item => {
                item.childList.forEach(item2 => {
                    if (item2.isCheck) {
                        delData.push(item2);
                    }
                });
            });
            if (delData.length === 0) {
                this.$message.warning('请勾选删除数据');
            } else {
                this.$confirm('是否确定要删除选择的数据？', '提示', {
                    confirmButtonText: '确定',
                    cancelButtonText: '取消',
                    type: 'warning'
                }).then(async() => {
                    this.loadDel = true;
                    const res = await delList(delData);
                    this.loadDel = false;
                    if (res && res.code === '0') {
                        this.init();
                        this.$message({
                            message: '删除成功',
                            type: 'success'
                        });
                    }
                }).catch(() => {});
            }
        },
        async init() {
            this.exporDetailtURl = `/api-srm-web/bid/exportCompositeScore/${this.$route.query.bidNo}`;
            this.exportParams = { bidNo: this.$route.query.bidNo };
            this.uploadParams = { bidNo: this.$route.query.bidNo };
            this.bidStatus = this.loginState.bidStatus;
            if (this.bidStatus === '00' || this.bidStatus === '20') {
                this.saveBtn = true;
            } else {
                this.saveBtn = false;
            }
            const res = await scoreList({ bidNo: this.$route.query.bidNo });
            if (res && res.code === '0') {
                this.tableData = res.data;
                this.tableData.forEach(item => {
                    item.isCheck = false;
                    item.disabled = true;
                    item.childList.forEach(item2 => {
                        item2.isCheck = false;
                    });
                });
            }
        },
        inputScore(row, scope) {
            this.tableData.forEach(item => {
                let sum = 0;
                if (item.scoreAttribute === row.scoreAttribute) {
                    item.childList.forEach(item2 => {
                        sum += item2.scoreScale;
                    });
                    item.scoreScale = sum;
                    this.expandList.push(...item.childList);
                }
            });
            // this.expandList.push(row);
        },
        conversionData(val) {
            val = this.dictData.BID_SCORING_ATTRIBUTE[val];
            return val;
        },
        scorBtn() {
            this.$router.push({
                name: 'comprehensivegrade',
                query: { bidNo: this.$route.query.bidNo }
            });
        }
    },
    computed: { // 获取vuex
        loginState: function() {
            return this.$store.state.bidData;
        }
    }
};
</script>
<style  lang='less'>
.grade-template {
  padding: 16px;
  .cell {
    display: flex;
    align-items: center;
  }
  .grade-top {
    display: flex;
    justify-content: space-between;
    .grade-top-left {
      display: flex;
    }
    .btn-span{margin-right: 10px;}
    .grade-top-right {
      display: flex;
      align-items: center;
      cursor:pointer;
      .el-dropdown-link{
        color:#00bcbf;font-size: 14px;margin-right:10px;
      }
    }
    .el-icon-upload2,
    .el-icon-download {
      color: #00bcbf;
    }
    .load-info {
      font-size: 14px;
      margin-right: 20px;
      color: #666;
      cursor: pointer;
    }
  }
  .grade-table {
    margin-top: 15px;
      .el-table {
        min-height: calc(~ '100vh - 320px');
        max-height: calc(~ '100vh - 320px');
    }
  }
   .el-table--border{ border: 1px solid #ebeef5;}
}
</style>